import Request from '@hotmart/request'
import { CONTEXT_REQUEST_IDENTIFIERS } from './context.constants'

Request.register(`${process.env.API_BUSINESS_WORKSPACE}/v1`, {
  get: {
    [CONTEXT_REQUEST_IDENTIFIERS.GUIDE_TOUR]: '/user/viewed-guide-tour',
    [CONTEXT_REQUEST_IDENTIFIERS.MAIN_MENU]: '/menu/main',
    [CONTEXT_REQUEST_IDENTIFIERS.MAIN_BAR]: '/menu/main-bar',
    [CONTEXT_REQUEST_IDENTIFIERS.NOTIFICATION_LIST]: '/notification/current?appRequester=APP_BW&cluster=:cluster',
    [CONTEXT_REQUEST_IDENTIFIERS.TYPE_INFO]: '/user/type-info',
    [CONTEXT_REQUEST_IDENTIFIERS.SIDE_MENU]: '/side-menu'
  },
  put: {
    [CONTEXT_REQUEST_IDENTIFIERS.NOTIFICATION_UPDATE]: '/notification/:ucode'
  },
  post: {
    [CONTEXT_REQUEST_IDENTIFIERS.GUIDE_TOUR_UPDATE]: '/user/viewed-guide-tour',
    [CONTEXT_REQUEST_IDENTIFIERS.NOTIFICATION_CLICK_EVENT]: '/notification/sendEvent?appRequester=APP_BW'
  }
})

Request.register(`${process.env.API_HOTMART_PRO}/v1`, {
  get: {
    [CONTEXT_REQUEST_IDENTIFIERS.GUIDE_TOUR_HOTMART_PRO]: '/onboarding/creator/:creatorExternalId/exists?type=:type'
  },
  post: {
    [CONTEXT_REQUEST_IDENTIFIERS.GUIDE_TOUR_HOTMART_PRO_UPDATE]: '/onboarding'
  }
})
